import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const DetailsLink = styled(Link)`
  color: ${({ theme }) => theme.colors.secondary};

  &:hover {
    text-decoration: underline;
    transition: 0.3s;
  }
`

export const Spacer = styled.div`
  height: ${({ theme }) => theme.spacings[2]};
`
